// polyfills
import 'babel-polyfill';
import 'element-closest';

// source
import './web';
import './configureWeb';
import './configurePartialUpdate';
//import './configureTurbolinks';

// css
import '../css/main.scss';


// WEBPACK FOOTER //
// ./config/module-publish/resources-cvrez/js/index.js